module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container p-3",
    attrs: {
      "id": "exam"
    }
  }, [(_vm.examData.parts) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 pt-2 pb-3"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.5em"
    }
  }, [_vm._v(_vm._s(_vm.examData.parts[_vm.partNum].isListening ? 'Listening Test' : 'Reading Test'))])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.examData.parts), function(part, partIndex) {
    return (partIndex == _vm.partNum) ? _c('div', {
      key: partIndex,
      staticClass: "row questions"
    }, [_c('div', {
      staticClass: "card pl-0 pr-0 text-left",
      class: {
        'col-sm-12': !_vm.twoCols, 'col-sm-6': _vm.twoCols
      }
    }, [_c('div', {
      staticClass: "card-header"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_vm._v("\n            " + _vm._s(part.name) + "\n            "), (_vm.questNum > 0) ? _c('span', {
      staticClass: "float-right"
    }, [_vm._v(" Questions:\n              " + _vm._s(part.questions[_vm.questNum - 1].questionType === 'Package' ?
      part.questions[_vm.questNum - 1].childs[0].num :
      part.questions[_vm.questNum - 1].num) + " / " + _vm._s(_vm.questionCounts) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 text-left"
    }, [_vm._v("\n            " + _vm._s(part.questionCount) + " questions in total\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 text-right"
    }, [(_vm.questionTimer && _vm.questionTimer >= 0) ? _c('span', {
      staticClass: "mr-1"
    }, [_vm._v("Answer time: "), _c('img', {
      attrs: {
        "src": require("../assets/images/btn_text_slow_on.png")
      }
    }), _vm._v(" " + _vm._s(_vm.duration(_vm.questionTimer)))]) : _vm._e(), _vm._v("\n            Total time: "), _c('img', {
      attrs: {
        "src": require("../assets/images/btn_text_slow_on.png")
      }
    }), _vm._v(" "), _c('span', {
      class: {
        'text-danger': _vm.timer <= 900
      }
    }, [_vm._v(_vm._s(_vm.duration(_vm.timer)))])])])]), _vm._v(" "), (_vm.questNum === 0) ? _c('div', {
      staticClass: "card-body"
    }, [(_vm.currentPart.descriptionAudioUrl && _vm.isMobileDevice) ? _c('span', {
      on: {
        "click": function($event) {
          _vm.play(_vm.currentPart.descriptionAudioUrl)
        },
        "mouseover": function($event) {
          _vm.speakerHover = true
        },
        "mouseout": function($event) {
          _vm.speakerHover = false
        }
      }
    }, [(!_vm.speakerHover) ? _c('img', {
      staticClass: "btn-click",
      attrs: {
        "src": require("../assets/images/btn_play_sound_off.png")
      }
    }) : _c('img', {
      staticClass: "btn-click",
      attrs: {
        "src": require("../assets/images/btn_play_sound_on.png")
      }
    })]) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(part.description)
      }
    })]) : _vm._e(), _vm._v(" "), _vm._l((part.questions), function(question, questIndex) {
      return (_vm.questNum === questIndex + 1) ? _c('div', {
        key: questIndex,
        staticClass: "card-body"
      }, [(question.questionType === 'MultiChoice') ? _c("MultiChoice", {
        tag: "div",
        attrs: {
          "question": question,
          "selected": _vm.selectedAnswer(question.id),
          "canAudioReplay": (_vm.isMobileDevice || _vm.examData.parts[_vm.partNum].endDelay === null)
        },
        on: {
          "answer": _vm.handleAnswer
        }
      }) : _vm._e(), _vm._v(" "), (question.questionType === 'Package') ? _c('div', {
        staticClass: "row",
        staticStyle: {
          "height": "100%"
        }
      }, [_c('div', {
        staticClass: "col-sm-6",
        staticStyle: {
          "height": "100%",
          "overflow-y": "scroll"
        }
      }, [_c('p', [_vm._v("\n              " + _vm._s(question.num ? question.num + '. ' : '') + "\n              "), (question.audio && (_vm.isMobileDevice || _vm.examData.parts[_vm.partNum].endDelay === null)) ? _c('span', {
        on: {
          "click": function($event) {
            _vm.play(question.audio)
          },
          "mouseover": function($event) {
            _vm.speakerHover = true
          },
          "mouseout": function($event) {
            _vm.speakerHover = false
          }
        }
      }, [(!_vm.speakerHover) ? _c('img', {
        staticClass: "btn-click",
        attrs: {
          "src": require("../assets/images/btn_play_sound_off.png")
        }
      }) : _c('img', {
        staticClass: "btn-click",
        attrs: {
          "src": require("../assets/images/btn_play_sound_on.png")
        }
      })]) : _vm._e()]), _vm._v(" "), (question.image) ? _c('p', [_c('img', {
        attrs: {
          "src": question.image,
          "width": "100%"
        }
      })]) : _vm._e(), _vm._v(" "), (question.title) ? _c('p', {
        staticClass: "pre",
        domProps: {
          "innerHTML": _vm._s(question.title)
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-6",
        staticStyle: {
          "height": "100%",
          "overflow-y": "scroll"
        }
      }, _vm._l((question.childs), function(childQuestion, qcindex) {
        return (childQuestion.questionType === 'MultiChoice') ? _c("MultiChoice", {
          key: qcindex,
          tag: "div",
          staticClass: "pb-2 pt-2",
          attrs: {
            "question": childQuestion,
            "selected": _vm.selectedAnswer(childQuestion.id)
          },
          on: {
            "answer": _vm.handleAnswer
          }
        }) : _vm._e()
      }), 1)]) : _vm._e()], 1) : _vm._e()
    }), _vm._v(" "), (_vm.examData.parts[_vm.partNum].endDelay === null) ? _c('div', {
      staticClass: "card-footer text-sm-center"
    }, [(!(partIndex === 0 && _vm.questNum === 0)) ? _c('a', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.prev()
        }
      }
    }, [_vm._v("Previous")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "btn btn-primary ml-1",
      on: {
        "click": function($event) {
          _vm.next()
        }
      }
    }, [_vm._v("\n          " + _vm._s((partIndex === _vm.examData.parts.length - 1 && part.questions.length === _vm.questNum) ? 'Finish' : 'Next') + "\n        ")])]) : _vm._e()], 2), _vm._v(" "), (_vm.twoCols) ? _c('div', {
      staticClass: "card col-sm-5 ml-3 answer-sheet"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
      staticClass: "card-body"
    }, [_c('ul', {
      staticClass: "list-group"
    }, _vm._l((10), function(n) {
      return _c('li', {
        key: n,
        staticClass: "list-group-item"
      }, [_c('span', [_vm._v(_vm._s(n) + ". ")]), _vm._v(" "), _c('Options', {
        on: {
          "answer": _vm.handleAnswer
        }
      })], 1)
    }), 0)])]) : _vm._e()]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00fff072!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/live-player/components/Exam.vue
// module id = 700
// module chunks = 1